export default __webpack_public_path__ + "static/media/cta-btn.4a30def5.svg";